import { getUpdatedLocaleForURLAfterRegionSwitch } from '@src/components/locale/utils'
import { DEFAULT_LOCALE_PREFIX, LOCALE_COOKIE, TAbsoluteLocale } from '@src/config/i18n.config'
import regionDetailsHolder from '@src/quince-site-common/src/data-holders/regionDetails.holder'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { getStandardLocale, TRegionDetail } from '@src/utils/i18n.utils'
import { getLocaleFromUrlPath } from '@src/utils/urlLocale.utils'

const CHECKOUT_PATH = '/checkout'
const CHECKOUT_PATH_NEW = '/checkout/v2'

export const getLocalePrefix = (): string => {
  try {
    const locale = getCookie(LOCALE_COOKIE) as TAbsoluteLocale
    if (locale) {
      const localePrefix = getStandardLocale(locale)
      return localePrefix
    }
    return getLocaleFromUrlPath(DEFAULT_LOCALE_PREFIX)
  } catch (error) {
    console.error('Error getting locale prefix:', error)
    return DEFAULT_LOCALE_PREFIX
  }
}

/**
 * Creates a locale-prefixed checkout URL
 * @param baseUrl - The base checkout URL
 * @param checkoutId - The checkout ID
 * @param checkoutAuthCode - The checkout auth code
 * @returns The complete checkout URL with locale prefix (only if different from default)
 */
export const createLocalePrefixedCheckoutUrl = (
  baseUrl: string,
  checkoutId: string,
  checkoutAuthCode: string,
  showNewDesign: boolean,
  isI18nPreviewEnabled: boolean,
): string => {
  const locale = (getCookie(LOCALE_COOKIE) as TAbsoluteLocale) || DEFAULT_LOCALE_PREFIX
  const regionDetails = regionDetailsHolder.getRegionDetails() as TRegionDetail

  const updatedLocale = getUpdatedLocaleForURLAfterRegionSwitch(locale, regionDetails)
  const url = new URL(baseUrl)

  const path = showNewDesign ? CHECKOUT_PATH_NEW : CHECKOUT_PATH

  // Only add locale prefix if it's different from the default locale
  if (updatedLocale === '' || !isI18nPreviewEnabled) {
    url.pathname = path
  } else {
    url.pathname = `/${updatedLocale}${path}`
  }

  url.searchParams.set('checkoutId', checkoutId)
  url.searchParams.set('checkoutAuthCode', checkoutAuthCode)

  return url.href
}
